import * as React from 'react';
import System from 'src/helper/system';

const PlaceOrderFeedback = (props) => {
    const { SetStatus } = props;
    const { storageName } = System
    const { translation:t } = System;

    const closePopup=()=>{
        localStorage.removeItem(storageName.ORDER_FEEDBACK)
        SetStatus(false)
    }
    return (
        <>
            <div className="avnet-modal modal-500">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={closePopup}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5 text-bold"> {t('weNeedYourFeedback')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mb-3">
                            <p className='mb-0 mt-2 text-center font-arial'>{t('feedbackLine1')} <b>{t('feedbackLine2')}</b> {t('feedbackLine3')}</p>
                            <p className='mb-0 mt-3 text-center font-arial'>{t('feedbackLine4')} <b>{t('feedbackLine5')}</b> {t('feedbackLine6')}</p>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-sm btn-secondary" data-dismiss="modal"
                                onClick={closePopup}>
                                No
                            </button>
                            <button type="button" className="bs5 btn btn-sm btn-primary" data-dismiss="modal"
                                onClick={() => {
                                    window.open("https://survey.usabilla.com/live/s/654d0fa192e76b3b2d37b314", "_blank");
                                    closePopup()
                                }}>
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PlaceOrderFeedback;